import { render, staticRenderFns } from "./CompareLegendIconDescriptions.vue?vue&type=template&id=7a422cef&scoped=true&"
var script = {}
import style0 from "./CompareLegendIconDescriptions.vue?vue&type=style&index=0&id=7a422cef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a422cef",
  null
  
)

export default component.exports